import sixteenByNines from './sixteenByNine.jsx';
import squares from './square.jsx';

const getPlaceholders = (aspectRatio) => {
  if (aspectRatio === '1:1') return squares;
  if (aspectRatio === '9:16' || aspectRatio === '16:9') return sixteenByNines;
  return null;
};

export default getPlaceholders;
